import { useContext } from 'react';
import { AdminDashboardContext } from '../contexts/adminDashboard/adminDashboardContext';

export const useAdminDashboardContext = () => useContext(AdminDashboardContext);
